import { render, staticRenderFns } from "./rightCertify.vue?vue&type=template&id=9532559c&scoped=true"
import script from "./rightCertify.vue?vue&type=script&lang=js"
export * from "./rightCertify.vue?vue&type=script&lang=js"
import style0 from "./rightCertify.vue?vue&type=style&index=0&id=9532559c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9532559c",
  null
  
)

export default component.exports